import React from 'react';
import { Space, Tag } from "antd";
import Table from "../../../../componets/Table";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "../../../../componets/Buttons";
import { setEditId, NotificationInterface } from "../../../../store/mine_craft/notificationsSlice";
import { EntityId } from "@reduxjs/toolkit";
import { formattedDate } from "../../../../helpers/DateHelpers";
import OptionalLink from "../../../../componets/OptionalLink";
import {useSearchParams} from "react-router-dom";
import {doHighlight} from "../../../../helpers/TextHelpers";

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const ids             = useAppSelector(state => state.mineCraft.notifications.ids);
  const notifications   = useAppSelector(state => state.mineCraft.notifications.entities);
  const data            = ids ? ids.map(id => notifications[id]) : [];
  const term            = searchParams.get('term') || '';

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const renderActiveLabel = (notify: boolean) => {
    if (notify) {
      return <Tag color="success">enabled</Tag>
    } else {
      return <Tag color="default">disabled</Tag>
    }
  }

  const renderNotification = (notification: NotificationInterface) => {
    return (
      <OptionalLink link={notification.url}>
        <div>{doHighlight(notification.title, term)}</div>
        <div>{doHighlight(notification.subtitle, term)}</div>
        <div>{doHighlight(notification.body, term)}</div>
      </OptionalLink>
    )
  }

  const columns: ColumnsType<NotificationInterface> = [
    {
      key: 'active',
      title: 'Active',
      render: (_, { active }) => renderActiveLabel(active),
      width: 60
    },

    {
      key: 'title',
      title: 'Name',
      render: (_, notification) => renderNotification(notification),
      width: 185,
      ellipsis: true
    },

    {
      key: 'slug',
      title: 'Slug',
      render: (_, { slug }) => <Tag color="processing">{slug.toUpperCase()}</Tag>,
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id}) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />
    </div>
  )
}

export default _ListTable;
